module.exports = __webpack_public_path__ + "static/media/app-section-mobile.41599d56.png";